"use client";

import { ArrowRight, ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceHeroMetal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const modelNames = ["TITAN 01", "FORGE", "CARBON", "STEEL", "TITAN 01", "FORGE", "CARBON", "STEEL"];
  return <section data-section-id="3315" id="service-hero-metal" className="bg-background text-foreground relative min-h-[800px] h-screen w-full overflow-hidden">
      <div ref={ref} className="relative grid grid-cols-1 lg:grid-cols-12 h-full w-full">
        {}
        <div className="col-span-1 lg:col-span-7 relative z-10 flex flex-col justify-center px-6 sm:px-10 lg:px-16 pt-24 pb-32 lg:py-0">
          {}
          <div className={`flex items-center gap-4 mb-8 lg:mb-12 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"}`}>
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-foreground">
              01 — Industrial Precision
            </span>
            <span className="h-px w-16 sm:w-24" style={{
            backgroundColor: "var(--primary)"
          }} />
          </div>

          {}
          <h1 className={`font-default font-extrabold text-foreground leading-[0.9] mb-8 lg:mb-12 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          letterSpacing: "-0.04em"
        }}>
            <span className="block text-[3.5rem] sm:text-[5rem] md:text-[6.5rem] lg:text-[7.5rem] xl:text-[8.75rem]">
              Metal, in its
            </span>
            <span className="block text-[3.5rem] sm:text-[5rem] md:text-[6.5rem] lg:text-[7.5rem] xl:text-[8.75rem] pl-8 sm:pl-16 lg:pl-20">
              strongest form.
            </span>
          </h1>

          {}
          <p className={`font-default text-muted-foreground text-base sm:text-lg max-w-[420px] mb-10 lg:mb-12 leading-relaxed transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Precision-engineered metal components, forged in our state-of-the-art facility since 2014.
          </p>

          {}
          <div className={`flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-10 transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Button asChild size="lg" className="group relative overflow-hidden bg-foreground text-background hover:bg-foreground h-14 px-8 font-default font-semibold text-sm uppercase tracking-widest shadow-2xl">
              <Link to="/CapabilitiesPage">
                <span className="relative z-10 flex items-center gap-3 transition-colors duration-500 group-hover:text-primary-foreground">
                  View Capabilities
                  <ArrowRight className="h-4 w-4" />
                </span>
                <span className="absolute inset-0 -translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-out" style={{
                backgroundColor: "var(--primary)"
              }} />
              </Link>
            </Button>

            <Link to="/ServicesPage" className="group inline-flex items-center gap-2 text-foreground font-default text-sm uppercase tracking-widest font-medium">
              <span className="relative">
                Our Process
                <span className="absolute left-0 -bottom-1 h-px w-8 group-hover:w-full transition-all duration-500 ease-out" style={{
                backgroundColor: "var(--primary)"
              }} />
              </span>
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        {}
        <div className="hidden lg:block lg:col-span-5 absolute right-0 top-0 h-full w-full lg:w-[45%]">
          <div className="relative h-full w-full overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_metal_forging.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_metal_forging.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_metal_forging.png-wvc-sizes" alt="Industrial metal forging process" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover object-center" />
            {}
            <div className="absolute inset-y-0 left-0 w-32" style={{
            background: "linear-gradient(to right, var(--background), transparent)"
          }} />
          </div>
        </div>

        {}
        <div className="block lg:hidden absolute inset-0 -z-0 opacity-20 pointer-events-none">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_metal_forging.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_metal_forging.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_metal_forging.png-wvc-sizes" alt="" loading="lazy" decoding="async" className="h-full w-full object-cover object-right" />
        </div>

        {}
        <div className="absolute bottom-0 left-0 right-0 lg:right-auto lg:w-[58%] border-t border-border z-20 bg-background/80 backdrop-blur-sm">
          
        </div>

        {}
        <div className="hidden lg:flex absolute bottom-8 right-8 z-20 flex-col items-center gap-3">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground" style={{
          writingMode: "vertical-rl"
        }}>
            Scroll
          </span>
          <div className="relative h-16 w-px overflow-hidden bg-border">
            <span className="absolute top-0 left-0 h-8 w-px animate-scroll-tick" style={{
            backgroundColor: "var(--primary)"
          }} />
          </div>
          <ChevronDown className="h-4 w-4 text-muted-foreground animate-bounce" />
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
        @keyframes scroll-tick {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
        .animate-scroll-tick {
          animation: scroll-tick 2s ease-in-out infinite;
        }
      `}</style>
    </section>;
}